import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.condition)?_c(VRow,[_c(VCol,{staticClass:"d-flex flex-col align-center loading-bar"},[_c('svg',{staticClass:"loading-spinner"},_vm._l((_vm.circles),function(item,index){return _c('circle',{key:index,attrs:{"cx":_vm.circlePositions[index] && _vm.circlePositions[index].x,"cy":_vm.circlePositions[index] && _vm.circlePositions[index].y,"r":item.radius,"fill":item.color}})}),0),_vm._v(" "+_vm._s(!_vm.message ? _vm.$t("loading") : _vm.message)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }